import script from "./StudentChoiceFooter.vue?vue&type=script&setup=true&lang=ts"
export * from "./StudentChoiceFooter.vue?vue&type=script&setup=true&lang=ts"

import "./StudentChoiceFooter.vue?vue&type=style&index=0&id=2657b5db&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2657b5db"]])

export default __exports__